import React from "react";
import themePropTypes from "../theme-prop-types";

const PhotoPreviewButton = ({
  name,
  preview,
  previewDescription,
  invalid,
  index,
  onClick,
  photosTotal,
  label
}) => {
  const btnFileRef = React.useRef(null);

  const isNeedFocus = (prev, tot, i) => {
    const photoIndex = i - 1;

    if (tot !== 0) {
      return !prev && tot === photoIndex;
    }
  };

  React.useEffect(() => {
    if (isNeedFocus(preview, photosTotal, index)) {
      btnFileRef.current.focus();
    }
  }, [photosTotal]);

  return (
    <button
      ref={btnFileRef}
      aria-label={label}
      type='button'
      name={name}
      onClick={onClick}
      className={`photo-button-web-sdk ${invalid ? "invalid" : ""}`}
      data-testid={`photo-button-${name}`}
    >
      {preview ? (
        <img
          src={preview}
          alt={previewDescription}
          aria-label={label}
          aria-live={index === photosTotal ? "assertive" : "off"}
        />
      ) : (
        <span className='photo-button-web-sdk-ico' />
      )}
    </button>
  );
};

PhotoPreviewButton.propTypes = themePropTypes.photoPreviewButton;

export default PhotoPreviewButton;
